<div class="div_venue">
  <div class="w-100 venues-header-container">
    <div class="back-to-venues-btn-container"><a [routerLink]="'/venues'" class="back-to-venues-btn">
      <i class="pi pi-arrow-left"></i></a>
    </div>
    <div class="venue_name_container d-flex flex-column">
      <label class="venue_name ellipsis">{{ venueName }}</label>
      <label class="lbl_top_venues fw-400-fs-32">{{'RESERVATION.RESERVATIONS' | translate}}</label>
    </div>
    <div class="d-flex flex-column align-items-end">
      <div class="refuse-reservations-btn" (click)="refused_dates_form.toggle($event); getVenueDetails(true);" #toggle_refused_dates>
        <img src="assets/icons/calendar_decline.svg" alt="refuse calendar">
      </div>
      <div class="w-100 d-flex justify-content-end mt-3">
        <button class="export-btn" (click)="exportExcelToEmail()">
          <span class="hide_mobile">{{'RESERVATION.EXPORT' | translate}}</span>
          <img src="assets/icons/download_24px.svg" alt="download_icon"></button>
      </div>
    </div>
  </div>
  <div class="reservations-container">
    <p-tabView (onChange)="getReservationsByStatus($event, true)" [(activeIndex)]="activeIndex">
      <p-tabPanel>
        <ng-template pTemplate="header">
          <span class="p-tabview-title">{{'RESERVATION.PRIORITY_LIST' | translate}}
            <img src="assets/icons/star_yellow_24px.svg" alt="star" style="width: 13px; height: 13px;">
          </span>
        </ng-template>
        <ng-container *ngTemplateOutlet="reservationsTemplatePriorityList"></ng-container>
      </p-tabPanel>
      <p-tabPanel header="{{'RESERVATION.RENDING' | translate}}">
        <ng-container *ngTemplateOutlet="reservationsTemplate"></ng-container>
      </p-tabPanel>
      <p-tabPanel header="{{'RESERVATION.ACCEPTED' | translate}}">
        <ng-container *ngTemplateOutlet="reservationsTemplate"></ng-container>
      </p-tabPanel>
      <p-tabPanel header="{{'RESERVATION.REJECTED' | translate}}">
        <ng-container *ngTemplateOutlet="reservationsTemplate"></ng-container>
      </p-tabPanel>
      <p-tabPanel header="{{'RESERVATION.PAST' | translate}}">
        <ng-container *ngTemplateOutlet="reservationsTemplate"></ng-container>
      </p-tabPanel>
      <p-tabPanel header="{{'RESERVATION.CANCELED' | translate}}">
        <ng-container *ngTemplateOutlet="reservationsTemplate"></ng-container>
      </p-tabPanel>
    </p-tabView>
  </div>
</div>

<ng-template #reservationsTemplatePriorityList>
  <div class="w-100 d-flex justify-content-end mt-3" style="height: 29.19px;"></div>
  <div class="w-100 medium_spinner_wrapper" *ngIf="spinner && this.paginationModel.pageNumber === 1">
    <p-progressSpinner></p-progressSpinner>
  </div>
  <div class="tab-content-pr" *ngIf="reservationList.length > 0"
       infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollUpDistance]="1000"
       (scrolled)="loadMoreReservations()" [scrollWindow]="false">
    <p-orderList [value]="reservationList" [dragdrop]="true" controlsPosition="top" [styleClass]="'priority-list'" [(selection)]="selectedReservation"
                 (onReorder)="onReorder($event)" [disabled]="reorderDisabled">
      <ng-template let-reservation let-index="index" pTemplate="item">
          <div class="d-flex flex-row priority-reservation-container">
            <div class="w-100 medium_spinner_wrapper position-absolute reorder_res_spinner_mbl" *ngIf="reorderDisabled && currentReorderingIndex === index">
              <p-progressSpinner></p-progressSpinner>
            </div>
            <div class="d-flex user-container" title="{{reservation.firstName}} {{reservation.lastName}}">
              <div class="d-flex flex-row justify-content-between-mbl-wide">
                <span class="ellipsis">{{reservation.firstName}}</span>
                <p-badge *ngIf="reservation.mobileUserCategoryName && reservation.mobileUserCategoryName.trim() !== ''"
                         [ngClass]="{'vip': reservation.mobileUserCategoryName === 'VIP', 'super_vip': reservation.mobileUserCategoryName === 'Super VIP',
                         'simple': reservation.mobileUserCategoryName === 'Simple', 'regular': reservation.mobileUserCategoryName === 'Regular'}"
                         [value]="reservation.mobileUserCategoryName" styleClass="category-badge" class="ms-3"

                ></p-badge>
              </div>
              <span class="ellipsis">{{reservation.lastName}}</span>
            </div>
            <div class="d-flex flex-column">
              <span class="font-weight-800">{{'RESERVATION.DATE' | translate}}:</span>
              <span>{{reservation.reservationDateAndTime | date:'dd.MM.yyyy'}}</span>
            </div>
            <div class="d-flex flex-column">
              <span class="font-weight-800">{{'RESERVATION.TIME' | translate}}:</span>
              <span>{{reservation.reservationDateAndTime |  date:'hh:mm a'}}</span>
            </div>
            <div class="d-flex flex-column">
              <span class="font-weight-800">{{'RESERVATION.GUESTS' | translate}}:</span>
              <span>{{reservation.numberOfGuests}}</span>
            </div>
            <div class="d-flex flex-column">
              <button class="details_btn"
                      (click)="openDetailsPopup(reservation)">{{'RESERVATION.DETAILS' | translate}}</button>
            </div>
          </div>

      </ng-template>
    </p-orderList>
  </div>
</ng-template>

<ng-template #reservationsTemplate>
  <div class="w-100 medium_spinner_wrapper" *ngIf="spinner && this.paginationModel.pageNumber === 1">
    <p-progressSpinner></p-progressSpinner>
  </div>
  <div class="tab-content" *ngIf="reservationList.length > 0"
       infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollUpDistance]="1000"
       (scrolled)="loadMoreReservations()" [scrollWindow]="false">
    <div *ngFor="let reservation of reservationList">
      <div class="d-flex flex-row reservation-container">
        <div class="d-flex user-container" title="{{reservation.firstName}} {{reservation.lastName}}">
          <div class="d-flex flex-row justify-content-between-mbl-wide">
            <span class="ellipsis">{{reservation.firstName}}</span>
            <p-badge *ngIf="reservation.mobileUserCategoryName && reservation.mobileUserCategoryName.trim() !== ''"
                     [ngClass]="{'vip': reservation.mobileUserCategoryName === 'VIP', 'super_vip': reservation.mobileUserCategoryName === 'Super VIP',
                         'simple': reservation.mobileUserCategoryName === 'Simple', 'regular': reservation.mobileUserCategoryName === 'Regular'}"
                     [value]="reservation.mobileUserCategoryName" styleClass="category-badge" class="ms-3"

            ></p-badge>
          </div>
          <span class="ellipsis">{{reservation.lastName}}</span>
        </div>
        <div class="d-flex flex-column">
          <span class="font-weight-800">{{'RESERVATION.DATE' | translate}}:</span>
          <span>{{reservation.reservationDateAndTime | date:'dd.MM.yyyy'}}</span>
        </div>
        <div class="d-flex flex-column">
          <span class="font-weight-800">{{'RESERVATION.TIME' | translate}}:</span>
          <span>{{reservation.reservationDateAndTime |  date:'hh:mm a'}}</span>
        </div>
        <div class="d-flex flex-column">
          <span class="font-weight-800">{{'RESERVATION.GUESTS' | translate}}:</span>
          <span>{{reservation.numberOfGuests}}</span>
        </div>
        <div class="d-flex flex-column">
          <button class="details_btn"
                  (click)="openDetailsPopup(reservation)">{{'RESERVATION.DETAILS' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-container>
  <p-overlayPanel #refused_dates_form styleClass="refuse-reservations-form-container" (onHide)="resetDates()"
                  id="user_menu" [appendTo]="toggle_refused_dates" [dismissable]="true" [autoZIndex]="false">
    <div class="p-3" (click)="$event.stopPropagation()">
      <div class="refused_dates_header d-flex justify-content-between mb-2">
        <span class="header_text">{{'RESERVATION.REJECT_RESERVATIONS' | translate}}</span>
        <button type="button" class="custom-dialog-close-btn" (click)="refused_dates_form.hide(); resetDates()">
          <span class="pi pi-times"></span>
        </button>
      </div>
      <div>
        <label class="mb-2 choose-date-lbl">{{'RESERVATION.CHOOSE_DATE' | translate}}</label>
        <p-calendar #rangeCalendar class="range-date-picker" [(ngModel)]="dateRange"
                    selectionMode="range" [readonlyInput]="true" inputId="range" [showIcon]="true"
                    [firstDayOfWeek]="1" styleClass="higher-input" [touchUI]="isTouch">
          <ng-template pTemplate="date" let-date>
            <div class="calendar-item"
                 [ngClass]="{range_selecting: isRangeDate(date, 0, true),
                             endpoint_start: isRangeDate(date, 0),
                             endpoint_end: isRangeDate(date, 1)}">
              <span class="date">{{ date.day }}</span>
            </div>
          </ng-template>
          <ng-template pTemplate="footer">
            <div class="w-100 d-flex flex-row mt-4">
              <div class="w-50">
                <label class="time_lbl">{{'RESERVATION.START_TIME' | translate}}:</label>
                <p-calendar [(ngModel)]="fromTime" [timeOnly]="true" [inline]="true" inputId="timeonly"
                            [hourFormat]="'12'"></p-calendar>
              </div>
              <div class="w-50">
                <label class="time_lbl ps-0">{{'RESERVATION.END_TIME' | translate}}:</label>
                <p-calendar [(ngModel)]="toTime" [timeOnly]="true" [inline]="true" inputId="timeonly"
                            [hourFormat]="'12'"></p-calendar>
              </div>
            </div>
          </ng-template>
        </p-calendar>
      </div>
      <div class="refused_dates_list mt-2" *ngIf="listOfRefusedDates.length > 0">
        <span>{{'RESERVATION.REJECTED_RES' | translate}}</span>
        <div class="w-100 d-flex justify-content-center align-items-center w-100" *ngIf="datesSpinner" style="height: 153px;">
          <div class="">
            <p-progressSpinner class="w-100 text-center pos_spinner_small"></p-progressSpinner>
          </div>
        </div>
        <div class="mt-2 dates_container" *ngIf="!datesSpinner">
          <div *ngFor="let dateTime of listOfRefusedDates" class="d-flex flex-row justify-content-between mb-2">
            <div class="d-flex flex-column w-80">
              <span><span class="lbl">{{'RESERVATION.DATE' | translate}}: </span><span class="vl">{{dateTime.startDateTime | date: 'dd.MM.yyyy'}}-{{dateTime.endDateTime | date: 'dd.MM.yyyy'}}</span></span>
              <span><span class="lbl">{{'RESERVATION.TIME' | translate}}: </span>
                <span class="vl" *ngIf="showTime(dateTime)">{{parseTime(dateTime.rangeStartTime) | date: 'h.mm a'}}-{{parseTime(dateTime.rangeEndTime) | date: 'h.mm a'}}</span>
                <span class="vl" *ngIf="!showTime(dateTime)">-</span>
              </span>
            </div>
            <div class="d-flex flex-row w-20 justify-content-end">
              <button pButton pRipple type="button" icon="pi pi-trash" class="p-button-rounded table-btn"
                      (click)="deleteNotAllowedPeriod(dateTime.id)"></button>
            </div>
          </div>
        </div>
      </div>
      <button [disabled]="dateRange.length < 2 || !dateRange[1]" class="create_btn w-100 mt-2 mb-3"
              (click)="addRefuseReservationsRange()">
        <span>{{'ADD'| translate}}</span>
      </button>
    </div>
  </p-overlayPanel>
</ng-container>
